import { render, staticRenderFns } from "./tiscHeader.vue?vue&type=template&id=a26038ea&scoped=true&"
import script from "./tiscHeader.vue?vue&type=script&lang=js&"
export * from "./tiscHeader.vue?vue&type=script&lang=js&"
import style0 from "./tiscHeader.vue?vue&type=style&index=0&id=a26038ea&lang=scss&scoped=true&"
import style1 from "./tiscHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26038ea",
  null
  
)

export default component.exports